<template>
  <div id="zavislosti_po">
    <general-form-component
      :item-id="$route.params.id"
      form-name="HODNOTIACE ŠKÁLY PO ABSOLVOVANÍ ŠRaVVP ZÁVISLOSTI"
      :items="items"
      :dialogs="dialogs"
      :get-item-function="getItemFunction"
      :update-item-function="updateItemFunction"
    />
  </div>
</template>


<script>
import { APIService } from "@/http/APIService.js";
const apiService = new APIService();

import GeneralFormComponent from "./GeneralFormComponent.vue";

export default {
  components: {
    "general-form-component": GeneralFormComponent,
  },
  data: () => ({
    items: [
      {
        name: "intrapersonalne_schopnosti",
        fullName: "Intrapersonálne schopnosti odsúdeného vzhľadom k závislosti",
        radios: [
          {
            color: "red",
            label: "Odsúdený vykazuje veľmi nízku úroveň sebauvedomenia a sebapoznania.",
            value: 4
          },
          {
            color: "orange",
            label: "Odsúdený vykazuje nízku úroveň sebauvedomenia a sebapoznania.",
            value: 3
          },
          {
            color: "yellow",
            label: "Odsúdený vykazuje strednú úroveň sebauvedomenia a sebapoznania.",
            value: 2
          },
          {
            color: "blue",
            label: "Odsúdený vykazuje vysokú úroveň sebauvedomenia a sebapoznania.",
            value: 1
          },
          {
            color: "green",
            label: "Odsúdený vykazuje veľmi vysokú úroveň sebauvedomenia a sebapoznania.",
            value: 0
          }
        ],
        textfields: [
          {
            name: "pocet_hodin_intrapersonalne_schopnosti",
            fullName: "Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
          }
        ]
      },

      {
        name: "motivacia_k_zmene_zivotneho_stylu",
        fullName: "Motivácia k zmene životného štýlu",
        radios: [
          {
            color: "red",
            label: "Odsúdený nie je absolútne motivovaný k zmene svojho životného štýlu.",
            value: 4
          },
          {
            color: "orange",
            label: "Odsúdený nie je dostatočne motivovaný k zmene svojho životného štýlu.",
            value: 3
          },
          {
            color: "yellow",
            label: "Odsúdený si je vedomý existencie problémov v súvislosti so závislosťou, je čiastočne motivovaný k zmene svojho životného štýlu.",
            value: 2
          },
          {
            color: "blue",
            label: "Odsúdený je motivovaný k celkovej zmene životného štýlu.",
            value: 1
          },
          {
            color: "green",
            label: "Odsúdený je vysoko motivovaný k celkovej zmene životného štýlu.",
            value: 0
          }
        ],
        textfields: [
          {
            name: "pocet_hodin_motivacia_k_zmene_zivotneho_stylu",
            fullName: "Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
          }
        ]
      },

      {
        name: "komunikacia",
        fullName: "Komunikácia",
        radios: [
          {
            color: "red",
            label: "Komunikácia odsúdeného vykazuje výrazne negatívne aspekty verbálnej aj neverbálnej komunikácie.",
            value: 4
          },
          {
            color: "orange",
            label: "Komunikácia odsúdeného vykazuje prevažne negatívne aspekty verbálnej a neverbálnej komunikácie.",
            value: 3
          },
          {
            color: "yellow",
            label: "Komunikácia odsúdeného vykazuje ako negatívne, tak pozitívne aspekty verbálnej a neverbálnej komunikácie.",
            value: 2
          },
          {
            color: "blue",
            label: "Komunikácia odsúdeného vykazuje prevažne pozitívne aspekty verbálnej a neverbálnej komunikácie.",
            value: 1
          },
          {
            color: "green",
            label: "Komunikácia odsúdeného vykazuje výrazne pozitívne aspekty verbálnej a neverbálnej komunikácie.",
            value: 0
          }
        ],
        textfields: [
          {
            name: "pocet_hodin_komunikacia",
            fullName: "Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
          }
        ]
      },

      {
        name: "sebapresadenie",
        fullName: "Sebapresadenie",
        radios: [
          {
            color: "red",
            label: "U odsúdeného prevládajú pri sebapresadzovaní výrazne negatívne (až egocentrické) prvky správania.",
            value: 4
          },
          {
            color: "orange",
            label: "U odsúdeného sa občas vyskytujú negatívne prvky správania.",
            value: 3
          },
          {
            color: "yellow",
            label: "U odsúdeného sa objavujú negatívne, ale v tej istej miere aj pozitívne črty správania.",
            value: 2
          },
          {
            color: "blue",
            label: "U odsúdeného sa prejavujú prevažne pozitívne prvky správania.",
            value: 1
          },
          {
            color: "green",
            label: "U odsúdeného prevládajú zásadne pozitívne prvky správania.",
            value: 0
          }
        ],
        textfields: [
          {
            name: "pocet_hodin_sebapresadenie",
            fullName: "Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
          }
        ]
      },

      {
        name: "riesenie_konfliktov",
        fullName: "Riešenie konfliktov",
        radios: [
          {
            color: "red",
            label: "U odsúdeného úplne absentuje schopnosť riešiť konflikty adaptívne.",
            value: 4
          },
          {
            color: "orange",
            label: "U odsúdeného je schopnosť riešiť konflikty na nízkej úrovni.",
            value: 3
          },
          {
            color: "yellow",
            label: "Odsúdený vykazuje priemernú schopnosť riešiť konflikty.",
            value: 2
          },
          {
            color: "blue",
            label: "Odsúdený vykazuje schopnosť riešiť konflikty na vyššej úrovni.",
            value: 1
          },
          {
            color: "green",
            label: "Odsúdený vykazuje schopnosť riešiť konflikty na vysokej úrovni.",
            value: 0
          }
        ],
        textfields: [
          {
            name: "pocet_hodin_riesenie_konfliktov",
            fullName: "Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
          }
        ]
      },

      {
        name: "riziko_cravingu",
        fullName: "Riziko cravingu u odsúdeného",
        radios: [
          {
            color: "red",
            label: "Výskyt rizikových faktorov pre objavovanie sa cravingu (túžby po užití drogy resp. závislej činnosti a navodení zodpovedajúceho stavu) u odsúdeného je veľmi vysoký.",
            value: 4
          },
          {
            color: "orange",
            label: "Výskyt rizikových faktorov vzniku cravingu u odsúdeného je vysoký.",
            value: 3
          },
          {
            color: "yellow",
            label: "Výskyt rizikových faktorov vzniku cravingu u odsúdeného je stredne vysoký.",
            value: 2
          },
          {
            color: "blue",
            label: "U odsúdeného málokedy pozorujeme výskyt rizikových faktorov vzniku cravingu ako aj samotný craving.",
            value: 1
          },
          {
            color: "green",
            label: "U odsúdeného nepozorujeme výskyt rizikových faktorov ani prejavy cravingu.",
            value: 0
          }
        ],
        textfields: [
          {
            name: "pocet_hodin_riziko_cravingu",
            fullName: "Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
          }
        ]
      },

      {
        name: "prevencia_a_zvladnutie_relapsu",
        fullName: "Prevencia a zvládanie relapsu (kompetencie)",
        radios: [
          {
            color: "red",
            label: "Odsúdený absolútne nedisponuje kompetenciami na zvládanie situácií zvýšeného rizika relapsu.",
            value: 4
          },
          {
            color: "orange",
            label: "Kompetencie odsúdeného na zvládnutie situácií zvýšeného rizika relapsu sú veľmi obmedzené.",
            value: 3
          },
          {
            color: "yellow",
            label: "Kompetencie odsúdeného na zvládnutie situácií zvýšeného rizika relapsu sú obmedzené.",
            value: 2
          },
          {
            color: "blue",
            label: "Odsúdený má dostatočné kompetencie na zvládanie rizikových situácií a stresu.",
            value: 1
          },
          {
            color: "green",
            label: "Odsúdený prejavuje primerané a dostatočné  kompetencie na zvládanie rizikových situácií a stresu.",
            value: 0
          }
        ],
        textfields: [
          {
            name: "pocet_hodin_prevencia_a_zvladnutie_relapsu",
            fullName: "Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
          }
        ]
      },

      {
        name: "socialne_dosledky_zavislosti_sirsie",
        fullName: "Sociálne dôsledky závislosti - širšie medziľudské vzťahy",
        radios: [
          {
            color: "red",
            label: "Odsúdený nemá vôbec žiadny záujem o udržiavanie kvalitných medziľudských vzťahov mimo rodiny.",
            value: 4
          },
          {
            color: "orange",
            label: "Odsúdený nemá takmer žiadny záujem o udržiavanie kvalitných medziľudských vzťahov mimo rodiny.",
            value: 3
          },
          {
            color: "yellow",
            label: "Odsúdený má celkom slabý záujem o udržiavanie kvalitných medziľudských vzťahov mimo rodiny.",
            value: 2
          },
          {
            color: "blue",
            label: "Odsúdený má mierne oslabený záujem o udržiavanie kvalitných medziľudských vzťahov mimo rodiny.",
            value: 1
          },
          {
            color: "green",
            label: "Odsúdený má primeraný záujem o udržiavanie kvalitných medziľudských vzťahov mimo rodiny.",
            value: 0
          }
        ],
        textfields: [
          {
            name: "pocet_hodin_socialne_dosledky_zavislosti_sirsie",
            fullName: "Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
          }
        ]
      },

      {
        name: "socialne_dosledky_zavislosti",
        fullName: "Sociálne dôsledky závislosti - uvedomenie si sociálnych škôd spôsobených závislosťou",
        radios: [
          {
            color: "red",
            label: "Odsúdený si vôbec nie je vedomý toho, aké následky spôsobuje jeho závislosť vlastnej rodine, blízkym a širšiemu sociálnemu okoliu.",
            value: 4
          },
          {
            color: "orange",
            label: "Odsúdený si takmer vôbec nie je vedomý toho, aké následky spôsobuje jeho závislosť vlastnej rodine, blízkym a širšiemu sociálnemu okoliu.",
            value: 3
          },
          {
            color: "yellow",
            label: "Odsúdený si je čiastočne vedomý toho, aké následky spôsobuje jeho závislosť vlastnej  rodine, blízkym a širšiemu sociálnemu okoliu.",
            value: 2
          },
          {
            color: "blue",
            label: "Odsúdený si je dostatočne vedomý toho, aké následky spôsobuje jeho závislosť vlastnej  rodine, blízkym a širšiemu sociálnemu okoliu.",
            value: 1
          },
          {
            color: "green",
            label: "Odsúdený si je úplne vedomý toho, aké následky spôsobuje jeho závislosť vlastnej  rodine, blízkym a širšiemu sociálnemu okoliu.",
            value: 0
          }
        ],
        textfields: [
          {
            name: "pocet_hodin_socialne_dosledky_zavislosti",
            fullName: "Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
          }
        ]
      },


      {
        name: "zaverecne_hodnotenie",
        fullName: "Záverečné hodnotenie progresu u odsúdeného po absolvovaní ŠRaVVP Závislosti",
        radios: [
          {
            color: "red",
            label: "Bez zlepšenia.",
            value: 4
          },
          {
            color: "orange",
            label: "S minimálnym zlepšením.",
            value: 3
          },
          {
            color: "yellow",
            label: "S miernym zlepšením.",
            value: 2
          },
          {
            color: "blue",
            label: "S citeľným zlepšením.",
            value: 1
          },
          {
            color: "green",
            label: "S výrazným zlepšením.",
            value: 0
          }
        ],
        textfields: [
          {
            name: "pocet_hodin_zaverecne_hodnotenie",
            fullName: "Absolvovaný počet hodín štandardných intervencií tematickej oblasti"
          }
        ]
      }
    ],
    dialogs: {
      intrapersonalne_schopnosti: {
        nazov: "Intrapersonálne schopnosti odsúdeného vzhľadom k závislosti",
        texts: [
          "Odsúdený vykazuje veľmi nízku úroveň sebauvedomenia a sebapoznania. Má vyslovene chudobný fantazijný svet, má veľmi nízku schopnosť popisovať vlastné emócie, porozumieť im a regulovať ich. Schopnosť predpovedať svoje vlastné správanie vzhľadom k závislosti a rozpoznať blížiace sa nebezpečenstvo je veľmi nízka. U odsúdeného absentuje schopnosť realistickej predstavy o svojich vlastnostiach, schopnostiach, charaktere a temperamente, nemá žiadne plány na život v súvislosti so životom bez závislosti po prepustení. Na akúkoľvek spätnú väzbu od odborníka ohľadom závislostí reaguje vyslovene neprimerane, dysfunkčne.",
          "Odsúdený vykazuje nízku úroveň sebauvedomenia a sebapoznania. Jeho fantazijný svet je chudobný, o svojich emóciách dokáže rozprávať len na základe pomocných otázok od lektora, nevie im samostatne porozumieť. Schopnosť predpovedať svoje vlastné správanie a schopnosť rozpoznať blížiace sa nebezpečenstvo  vzhľadom k závislosti je nízka. Bagatelizuje problémy, avšak v rozhovore s odsúdeným sa dá pozorovať uvedomenie si rizikovosti vlastného správania. Schopnosť odsúdeného realisticky popísať svoje vlastnosti, schopnosti, charakter a temperament je nízka, snaží sa pôsobiť v lepšom svetle. Nedokáže dostatočne prijať spätnú väzbu od odborníka - reaguje popieraním  či inak neprimerane, prerušuje odborníka, snaží sa pred ním obhajovať. Realistické plány na život bez závislosti po prepustení absentujú.",
          "Odsúdený vykazuje strednú úroveň sebauvedomenia a sebapoznania. Svoje emócie je schopný čiastočne popísať, nie je ich však schopný bez pomoci dostatočne regulovať. Je schopný predpovedať svoje vlastné správanie v rôznych situáciách vzhľadom k závislosti, no nedokáže ich samostatne zvládnuť, nedokáže bez pomoci vhodne zareagovať na blížiace sa nebezpečenstvo. Rizikovosť vlastného správania si čiastočne uvedomuje, stále ho však bagatelizuje a nemá presné plány na život po VTOS (postoje typu “Tentokrát to už zvládnem”). Odsúdený je čiastočne schopný realisticky popísať svoje vlastnosti, schopnosti, charakter a temperament, nie je však schopný s nimi dostatočne samostatne a konštruktívne pracovať. Na negatívnu spätnú väzbu je citlivý, má tendenciu sa obhajovať, avšak je otvorený komunikácii o nej.",
          "Odsúdený vykazuje vysokú úroveň sebauvedomenia a sebapoznania. Svoje emócie je schopný popísať, nie je si však úplne istý, či ich dokáže samostatne ovládať. Je schopný predpovedať svoje vlastné správanie v rôznych situáciách vzhľadom k závislosti, no v náročných situáciách popisuje svoje obavy, že sa nedokáže ovládnuť a vhodne správne zareagovať na blížiace sa nebezpečenstvo. Rizikovosť vlastného správania a vlastnej osobnosti si uvedomuje, je pripravený týmto rizikám čeliť, má čiastočné plány na život po VTOS. Chce pokračovať v doliečovacom procese za pomoci profesionálov, zaujíma sa o možnosti tohto procesu po VTOS.",
          "Odsúdený vykazuje veľmi vysokú úroveň sebauvedomenia a sebapoznania. Svoje emócie je schopný popísať a dokáže ich aj samostatne ovládať. Je schopný predpovedať svoje vlastné správanie v rôznych situáciách vzhľadom k závislosti, trúfa si aj na zvládnutie náročných situácií bez pomoci druhej osoby. Je schopný sebaovládania a s najväčšou pravdepodobnosťou bude vedieť vhodne zareagovať na blížiace sa nebezpečenstvo. Rizikovosť vlastného správania a vlastnej osobnosti si uvedomuje, je pripravený týmto rizikám čeliť, má konkrétne plány na život po VTOS. Chce pokračovať v doliečovacom procese za pomoci profesionálov."
        ]
      },

      motivacia_k_zmene_zivotneho_stylu: {
        nazov: "Motivácia k zmene životného štýlu",
        texts: [
          "Odsúdený nie je absolútne motivovaný k zmene svojho životného štýlu, necíti potrebu zmeny, neakceptuje potrebu liečby závislosti ani vzdelávania sa v tejto oblasti. Nemá záujem meniť svoje doterajšie zaužívané zvyky a spôsoby správania. Absentuje sebareflexia, uvedomenie si vlastných chýb a miery pričinenia k existujúcim problémom v súvislosti so závislosťou. Príčiny externalizuje  („Štát sa o mňa nepostaral...., Nemal som kde bývať..., Nemal som prácu..., Kamaráti ma ťahali dole... Konzumácia drog/alkoholu alebo hranie automatov a pod mi pomohlo sa lepšie cítiť, zabudnúť na všetko...  lepšie sa vyrovnať s realitou... Závislý som určite nebol. Bez drogy dokážem bez problémov fungovať“). Akúkoľvek odbornú pomoc odmieta. Vôbec si nepripúšťa svoju závislosť.",
          "Odsúdený nie je dostatočne motivovaný k zmene svojho životného štýlu, aj napriek tomu, že čiastočne pripúšťa potrebu zmeny. Sebareflexia v súvislosti so závislosťou je nízka, čiastočne si uvedomuje existenciu problémov spojených so závislosťou, avšak stále ich zľahčuje a snaží sa z toho vyviniť. Nie je dostatočne motivovaný k vzdelávaniu sa v oblasti závislostí, nevie, čo ho čaká, drží sa hesla: „Ja to nejak zvládnem, už som si tým prešiel a viem, čomu sa vyhnúť. Nepotrebujem pomoc.“ Odbornú pomoc a liečenie stále odmieta. Svoju závislosť si čiastočne pripúšťa, avšak má pocit, že ju zvládne bez pomoci okolia.",
          "Odsúdený si je vedomý existencie problémov v súvislosti so závislosťou, je čiastočne motivovaný k zmene svojho životného štýlu. Nedokáže však urobiť dostatočné zmeny svojho životného štýlu bez pomoci svojho okolia a odborníkov. Je v stave, kedy zvažuje výhody vs. nevýhody tejto zmeny. Je potrebná pomoc odborníkov na udržanie jeho motivácie k zmene. Vzdelávanie v tejto oblasti neodmieta, liečeniu a  súvisiacim zmenám však nie je dostatočne prístupný.",
          "Odsúdený je motivovaný k celkovej zmene životného štýlu. Prítomnosť problémov, do ktorých sa kvôli závislosti dostal, pripúšťa, má motiváciu zmeniť svoj životný štýl, avšak nie je schopný samostatne bez pomoci odborníkov túto zmenu vykonať. Vzdelávať sa v oblasti závislostí chce, s ústavnou liečbou je aspoň čiastočne vyrovnaný, ambulantnú liečbu prijíma a spolupracuje, chce v nej pokračovať aj po VTOS. Svoj podiel na rozvinutej závislosti si uvedomuje a pripúšťa.",
          "Odsúdený je vysoko motivovaný k celkovej zmene životného štýlu, uvedomuje si, že sám sa nezvládne vysporiadať s problémami, do ktorých sa dostal kvôli závislosti. Svoju závislosť si pripúšťa, chce sa liečiť a vzdelávať v tejto oblasti. Má záujem spolupracovať s odborníkmi ako počas výkonu trestu, tak aj po prepustení na slobodu. Akceptuje potrebu liečby (ústavnej aj ambulantnej), je motivovaný k zmene a je nastavený zvládnuť aj niektoré straty, ktoré so zmenou súvisia. Zodpovednosť na rozvoji závislosti a za zmenu vidí najmä na svojej strane."
        ]
      },

      komunikacia: {
        nazov: "Komunikácia",
        texts: [
          "Komunikácia odsúdeného vykazuje výrazne negatívne aspekty verbálnej aj neverbálnej komunikácie. U odsúdeného sú prítomné výrazné komunikačné zlozvyky s agresívnou tendenciou, manipuluje svoje okolie, verbálne naň útočí a ponižuje ho.  Dominujú devalvačné prístupy. Nie je schopný udržať plynulú komunikáciu, neustále skáče do reči. Absentuje prítomnosť aktívneho počúvania. Je otvorene v odpore, odmieta druhú stranu. Často obviňuje druhých z vlastných zlyhaní a prekrúca skutočnosti, zveličuje a preháňa. V neverbálnej komunikácii sú zjavné prvky agresívneho správania. Komunikácia s odsúdeným je veľmi náročná, nie je možné ju odborne korigovať.",
          "Komunikácia odsúdeného vykazuje prevažne negatívne aspekty verbálnej a neverbálnej komunikácie. U odsúdeného sú prítomné komunikačné zlozvyky, s vyhýbavou tendenciou, neudržiava očný kontakt, často skáče do reči, odbáča od témy, nie je schopný udržať koncentráciu.   Je veľmi defenzívny a v skrytom odpore. Odsúdený manipuluje v rámci komunikácie tak, aby ju ukončil a tým dosiahol svoj pocit istoty a bezpečia.  V tomto zmysle aj vyjadruje súhlas s lektorom či ostatnými, ale len formálne, aby mal pokoj. Svoje emócie vyjadruje nepriamo, vyhýbavo, je neúprimný. Vyjadrovanie sa odsúdeného je nejasné a nekonkrétne, je prítomné zovšeobecňovanie a prekrúcanie skutočnosti. Prejavuje sa, uponáhľanosť, zaujatosť, vzťahovačnosť a nedostatok vlastného  záujmu. Komunikácia s odsúdeným je náročná, no je možné ju odborne korigovať.",
          "Komunikácia odsúdeného vykazuje ako negatívne, tak pozitívne aspekty verbálnej a neverbálnej komunikácie. Odsúdený komunikuje aktívne, hovorí odvážne s primeraným hlasom. U odsúdeného sa môžu pri citlivých témach vyskytnúť niektoré negatívne prvky ako napríklad manipulácia, vyhýbavé tendencie, nie je si istý obsahom, čo hovorí, občas uhýba očnému kontaktu, ale už je koncentrovanejší, nie je zaujatý, vzťahovačný a prejavuje dostatok záujmu. V prípade výskytu negatívnych komunikačných aspektov a pri odbornom usmernení je schopný adekvátne reagovať a prispôsobiť svoje komunikačné schopnosti rozhovoru.",
          "Komunikácia odsúdeného vykazuje prevažne pozitívne aspekty verbálnej a neverbálnej komunikácie.  Komunikuje otvorene, vecne a úprimne. Odsúdený dokáže porozumieť obsahu komunikácie, udržiava pozornosť a očný kontakt, rešpektuje  partnera v komunikácii, neskáče do reči. Jeho verbálny prejav je zreteľný a zrozumiteľný. Občas sú u neho pozorovateľné aj manipulatívne tendencie a iné účelové prvky v komunikácii (vyjadruje súhlas a pochopenie, keď sa mu to hodí, keď potrebuje niečo získať a podobne). Komunikácia s odsúdeným je prevažne bezproblémová, v prípade potreby ju je možné usmerňovať.",
          "Komunikácia odsúdeného vykazuje výrazne pozitívne aspekty verbálnej a neverbálnej komunikácie. Citlivo vníma, chápe a rešpektuje potreby každého člena z diskutujúcich, má adekvátny neverbálny prejav. Štýl komunikácie sa vyznačuje priamočiarosťou, dokáže vyjadriť jasne a primerane svoje pocity, myšlienky a túžby. Jeho verbálny prejav je zreteľný a zrozumiteľný, jeho reč je pokojná a plynulá.  Úprimne prejavuje záujem o názory iných, snaží sa porozumieť ich perspektíve, potrebám a podobne. Komunikácia s odsúdeným je bezproblémová, nie je potrebné ju nijako usmerňovať."
        ]
      },

      sebapresadenie: {
        nazov: "Sebapresadenie",
        texts: [
          "U odsúdeného prevládajú pri sebapresadzovaní výrazne negatívne (až egocentrické) prvky správania. V tomto type správania odsúdený agresívne presadzuje iba svoj názor bez ohľadu na to, či je správny alebo nie. Agresívne sebapresadzovanie môže byť charakterizované aj manipuláciou, tyranizovaním, hnevom, vulgárnym správaním, stratou sebakontroly a pod. Takýto odsúdení sú neobľúbení u ostatných, osamelí a izolovaní.",
          "U odsúdeného sa občas vyskytujú negatívne prvky správania. Odsúdený navonok berie ohľad na ostatných, ale prevažne dominantne presadzuje iba svoj názor bez ohľadu na to, či je správny alebo nie. Skryté agresívne sebapresadzovanie môže byť charakterizované aj manipuláciou, tyranizovaním, hnevom, vulgárnym správaním, stratou sebakontroly a pod. Takýto odsúdení môžu byť obľúbení u ostatných, nemusia byť osamelí a izolovaní.",
          "U odsúdeného sa objavujú negatívne, ale v tej istej miere aj pozitívne črty správania. Jeho správanie je charakteristické tým, že popiera vlastné práva a názory a veľmi ľahko prijíma riešenia ostatných. Odsúdený používa ospravedlňujúce frázy, submisívne výrazy, dostáva sa do interpersonálnych konfliktov, trpí depresiami a pocitom bezmocnosti. V spoločnosti sú neobľúbení, utiahnutí, vystresovaní, osamelí a izolovaní.",
          "U odsúdeného sa prejavujú prevažne pozitívne prvky správania. Odsúdený si váži seba aj ostatných, občas má pochybnosti o sebe a svojom konaní. Odsúdený dáva prednosť spolupráci, rozvoju priateľstva, pocitu spolupatričnosti, uspokojeniu potrieb všetkých zúčastnených, sebapresadeniu a vnútornej spokojnosti. Nie je úplne stotožnený s tým, kým je a tuší, aké sú jeho silné aj slabé stránky, no nie je schopný o nich otvorene rozprávať a pracovať s nimi.",
          "U odsúdeného prevládajú zásadne pozitívne prvky správania. Odsúdený si váži seba aj ostatných. Dáva prednosť spolupráci, rozvoju priateľstva, pocitu spolupatričnosti, uspokojeniu potrieb všetkých zúčastnených, sebapresadeniu a vnútornej spokojnosti. Je stotožnený s tým, kým je. Pozná svoje silné aj slabé stránky a aktívne vie o nich hovoriť aj sa primerane presadiť."
        ]
      },

      riesenie_konfliktov: {
        nazov: "Riešenie konfliktov",
        texts: [
          "U odsúdeného úplne absentuje schopnosť riešiť konflikty adaptívne. Ich riešeniu sa vyslovene vyhýba alebo reaguje prehnane agresívne. V prípade konfliktu, nemá záujem plniť požiadavky druhej strany, nie je schopný kompromisu, problémy buď pasívne ignoruje, odkladá ich na neurčito, nespolupracuje, alebo sa bezhlavo snaží presadiť svoje.  Odsúdený nedokáže predvídať následky svojho prístupu k riešeniu problémov, nie je pripravený na prechod do nového prostredia, nemá záujem o pomoc pri riešení konfliktov súvisiacich so závislosťou.",
          "U odsúdeného je schopnosť riešiť konflikty na nízkej úrovni. Pri riešení konfliktov sleduje svoje vlastné záujmy, nespolupracuje s druhou stranou, zameriava sa výhradne na seba. V rámci komunikácie využíva vlastnú schopnosť argumentácie na dosiahnutie svojho cieľa, alebo nátlakové a manipulatívne správanie. Pri riešení konfliktov je aktívny, nie je však konštruktívny.",
          "Odsúdený vykazuje priemernú schopnosť riešiť konflikty, pričom využíva kooperatívnu stratégiu, ktorá je nevyvážená. Pri riešení konfliktov sa podriaďuje, prihliada na uspokojenie záujmov druhej strany s ohľadom na zachovanie dobrých vzťahov na úkor pozitívneho výsledku v jeho prospech.  Svoje názory uplatňuje najmä vtedy, keď je vzťah medzi stranami nevyvážený. Uvedomuje si zvýšenú pravdepodobnosť vlastného podľahnutia závislosti pri konflikte, ale nehovorí o nej, nie je s ňou vyrovnaný. Sám nevyhľadáva odbornú pomoc, ale je ochotný počúvnuť silnejšiu (dominantnejšiu) autoritu. Z uvedeného sa dá predpokladať, že ho vhodné sociálne prostredie môže podporiť k používaniu konštruktívneho zvládania konfliktov a tým aj zníženiu pravdepodobnosti návratu resp. rozvinutia závislého správania.",
          "Odsúdený vykazuje schopnosť riešiť konflikty na vyššej úrovni. Využíva kooperatívnu a asertívnu stratégiu, riešeniu konfliktov sa nevyhýba, má snahu spolupracovať s cieľom uspokojiť nielen záujmy druhých, ale aj svoje vlastné. V rámci riešenia problémov sa môže vyskytnúť aj nesúhlas, avšak je otvorený dlhšej diskusii v snahe nájsť uspokojivé riešenie. Odsúdený si uvedomuje zvýšenú pravdepodobnosť vlastného podľahnutia závislosti pri ťažších či nezvládnutých konfliktoch.",
          "Odsúdený vykazuje schopnosť riešiť konflikty na vysokej úrovni. Jeho cieľom je nájsť prijateľné riešenie vhodné pre obe zúčastnené strany. Je schopný robiť kompromisy, no neprispôsobí sa každej situácii ak vie, že nie je správna. Problémy rieši priamo, konštruktívne a je ochotný obetovať svoje pohodlie s vedomím, že robí správnu vec. Disponuje vnútornou disciplínou, je schopný správneho rozhodnutia, dokáže čeliť sociálnemu tlaku a dokáže predvídať dôsledky svojho konania. Jeho úroveň schopnosti riešiť konflikty prispieva k nižšiemu riziku návratu k závislému správaniu po prepustení."
        ]
      },

      riziko_cravingu: {
        nazov: "Riziko cravingu u odsúdeného",
        texts: [
          "Výskyt rizikových faktorov pre objavovanie sa cravingu (túžby po užití drogy resp. závislej činnosti a navodení zodpovedajúceho stavu) u odsúdeného je veľmi vysoký. Veľmi často sa u neho prejavujú rizikové negatívne emócie (frustrácia, hnev, úzkosť, depresia, nuda) a fyzický diskomfort (tenzia, chronická bolesť a pod.). Veľmi často sa dostáva do konfliktov s okolím a nevie odolávať sociálnemu tlaku. V motivačných štruktúrach vidieť veľmi silnú orientáciu na psychoaktívne látky/nelátkové závislosti. Aspoň chvíľami je zrejmé, že cíti silnú túžbu po droge či závislej činnosti a v prípade jej dostupnosti by vysoko pravdepodobne drogu užil.",
          "Výskyt rizikových faktorov vzniku cravingu u odsúdeného je vysoký. Často sa u neho prejavujú rizikové negatívne emócie (frustrácia, hnev, úzkosť, depresia, nuda) a fyzický diskomfort (tenzia, chronická bolesť a pod.), často sa dostáva do konfliktov s okolím a nevie odolávať sociálnemu tlaku. V motivačných štruktúrach vidieť silnú orientáciu na psychoaktívne látky/nelátkové závislosti. Je zrejmá určitá snaha sa s túžbou po droge vyrovnávať. V rámci objavujúcej sa túžby po droge by ju v prípade dostupnosti pravdepodobne užil.",
          "Výskyt rizikových faktorov vzniku cravingu u odsúdeného je stredne vysoký. Bežne sa u neho prejavujú rizikové negatívne emócie (frustrácia, hnev, úzkosť, depresia, nuda) a fyzický diskomfort (tenzia, chronická bolesť a pod.), občas sa dostáva do konfliktov s okolím a ťažšie odoláva sociálnemu tlaku. Zo správania či sebavýpovede je zrejmé, že občas cíti craving. V motivačných štruktúrach vidieť v slabšej miere orientáciu na psychoaktívne látky/nelátkové závislosti, snaha s vlastnou túžbou po droge pracovať, schopnosť náhľadu na vlastný craving.",
          "U odsúdeného málokedy pozorujeme výskyt rizikových faktorov vzniku cravingu ako aj samotný craving. Miera výskytu rizikových negatívnych emócií (frustrácia, hnev, úzkosť, depresia, nuda) a fyzického diskomfortu (tenzia, chronická bolesť a pod.) sa blíži k bežnej nerizikovej populácii. Eventuálnym konfliktom s okolím a sociálnemu tlaku sa snaží predchádzať aplikáciou nadobudnutých sociálnych kompetencií, ktoré ešte nie sú pevne ukotvené. V motivačných štruktúrach vidieť silnú orientáciu na život bez psychoaktívnej látky/nelátkové závislosti.",
          "U odsúdeného nepozorujeme výskyt rizikových faktorov ani prejavy cravingu. Miera výskytu rizikových negatívnych emócií (frustrácia, hnev, úzkosť, depresia, nuda) a fyzického diskomfortu (tenzia, chronická bolesť a pod.) je porovnateľná s bežnou nerizikovou populáciou. Eventuálnym konfliktom s okolím a sociálnemu tlaku úspešne predchádza aplikáciou nadobudnutých sociálnych kompetencií. V motivačných štruktúrach vidieť veľmi silnú orientáciu na život bez psychoaktívnej látky/nelátkové závislosti. V prípade objavenia sa pocitov cravingu je o tom schopný otvorene a kriticky hovoriť, pocit túžby sa snaží aktívne zvládať a nerozvíjať napr. fantáziami a rozoberaním zážitkov „pod vplyvom“."
        ]
      },

      prevencia_a_zvladnutie_relapsu: {
        nazov: "Prevencia a zvládanie relapsu (kompetencie)",
        texts: [
          "Odsúdený absolútne nedisponuje kompetenciami na zvládanie situácií zvýšeného rizika relapsu. Vôbec nezvláda záťažové situácie a jeho sebadôvera, že sa zbaví závislosti, je veľmi nízka, čo zodpovedá vysokému riziku relapsu.",
          "Kompetencie odsúdeného na zvládnutie situácií zvýšeného rizika relapsu sú veľmi obmedzené. Záťažové situácie zvláda len s veľkými ťažkosťami a jeho sebadôvera, že sa zbaví závislosti, je veľmi nízka, čo zodpovedá zvýšenému riziku relapsu.",
          "Kompetencie odsúdeného na zvládnutie situácií zvýšeného rizika relapsu sú obmedzené. Záťažové situácie zvláda s ťažkosťami, čomu zodpovedá aj sebadôvera. Dokáže rozpoznať varovné známky možného zlyhania, no kompetencie na jeho odvrátenie nie sú dostatočne zvnútornené.",
          "Odsúdený má dostatočné kompetencie na zvládanie rizikových situácií a stresu. Ovláda asertívne techniky a snaží sa ich využívať na minimalizovanie rizika užitia návykovej látky, resp. opakovania správania vedúceho k nelátkovej závislosti. Dostatočne rozoznáva rizikové situácie a spúšťače rizikového konania a snaží sa na ne včas a primerane zareagovať.",
          "Odsúdený prejavuje primerané a dostatočné  kompetencie na zvládanie rizikových situácií a stresu. Ovláda asertívne techniky a vie ich využívať na minimalizovanie rizika užitia návykovej látky, resp. opakovania správania vedúceho k nelátkovej závislosti. Dostatočne rozoznáva rizikové situácie a spúšťače rizikového konania a vie na ne včas  a primerane zareagovať."
        ]
      },

      socialne_dosledky_zavislosti_sirsie: {
        nazov: "Sociálne dôsledky závislosti - širšie medziľudské vzťahy",
        texts: [
          "Odsúdený nemá vôbec žiadny záujem o udržiavanie kvalitných medziľudských vzťahov mimo rodiny, nemá vôbec žiadne pracovné návyky ani záujem o zamestnanie. Vôbec nejaví záujem naplniť ekonomické potreby seba a svojej rodiny.",
          "Odsúdený nemá takmer žiadny záujem o udržiavanie kvalitných medziľudských vzťahov mimo rodiny, nemá takmer žiadne pracovné návyky ani záujem o zamestnanie. Nejaví takmer žiadny záujem naplniť ekonomické potreby seba a svojej rodiny.",
          "Odsúdený má celkom slabý záujem o udržiavanie kvalitných medziľudských vzťahov mimo rodiny, má celkom slabé pracovné návyky a malý záujem o zamestnanie. Jeho záujem naplniť ekonomické potreby seba a svojej rodiny je slabý.",
          "Odsúdený má mierne oslabený záujem o udržiavanie kvalitných medziľudských vzťahov mimo rodiny, slabšie pracovné návyky a menší záujem o zamestnanie. Jeho záujem naplniť ekonomické potreby seba a svojej rodiny je obmedzený.",
          "Odsúdený má primeraný záujem o udržiavanie kvalitných medziľudských vzťahov mimo rodiny, pevné pracovné návyky a silný záujem o zamestnanie. Jeho záujem naplniť ekonomické potreby seba a svojej rodiny je výrazný."
        ]
      },

      socialne_dosledky_zavislosti: {
        nazov:
          "Sociálne dôsledky závislosti  - uvedomenie si sociálnych škôd spôsobených závislosťou",
        texts: [
          "Odsúdený si vôbec nie je vedomý toho, aké následky spôsobuje jeho závislosť vlastnej rodine, blízkym a širšiemu sociálnemu okoliu.",
          "Odsúdený si takmer vôbec nie je vedomý toho, aké následky spôsobuje jeho závislosť vlastnej rodine, blízkym a širšiemu sociálnemu okoliu.",
          "Odsúdený si je čiastočne vedomý toho, aké následky spôsobuje jeho závislosť vlastnej  rodine, blízkym a širšiemu sociálnemu okoliu.",
          "Odsúdený si je dostatočne vedomý toho, aké následky spôsobuje jeho závislosť vlastnej  rodine, blízkym a širšiemu sociálnemu okoliu.",
          "Odsúdený si je úplne vedomý toho, aké následky spôsobuje jeho závislosť vlastnej  rodine, blízkym a širšiemu sociálnemu okoliu."
        ]
      },
      zaverecne_hodnotenie: {
        nazov:
          "Záverečné hodnotenie progresu u odsúdeného po absolvovaní ŠRaVVP Závislosti",
        texts: [
          "Bez zlepšenia - Absolvovanie ŠRaVVP Závislosti neviedlo u odsúdeného k pozorovateľnému zlepšeniu. Nezískal potrebný náhľad na tému závislostí, vlastné rizikové správanie a vlastnosti spojené so závislosťou. Pretrváva u neho aktívny alebo pasívny odpor k zmene smerom k životu bez závislosti. Je len malá pravdepodobnosť že sa pokúsi vyhľadať odbornú či laickú pomoc pre ďalšie udržiavanie a upevňovanie správania bez závislostí. Je vysoké riziko, že sa po prepustení vráti k závislému správaniu.",
          "S minimálnym zlepšením - Absolvovanie ŠRaVVP Závislosti viedlo u odsúdeného k určitému pozorovateľnému zlepšeniu v jednej či viacerých oblastiach ako sú náhľad na závislosť, vlastné rizikové správanie a vlastnosti spojené so závislosťou, schopností aktívnej prevencie návratu k závislému správaniu a alebo motivácii na život bez závislosti po prepustení. Pravdepodobne nevyhľadá odbornú či laickú pomoc pre ďalšie udržiavanie a upevňovanie správania bez závislostí a je pomerne vysoké riziko, že sa vráti k závislému správaniu.",
          "S miernym zlepšením - Absolvovanie ŠRaVVP Závislosti viedlo u odsúdeného k miernemu zlepšeniu kompetencií a vedomostí potrebných pre lepšiu adaptáciu na život na slobode v jednej či viacerých oblastiach. Napriek zlepšeniu pretrváva jedno alebo viacero rizikových faktorov na strane odsúdeného ako je nedostatočná kontrola/sebadisciplína/zvládanie impulzivity, nedostatky v náhľade na vlastné či externé rizikové faktory, alebo iné nedostatky v schopnostiach, ktoré sú spojené s rizikom návratu k závislému správaniu.",
          "S citeľným zlepšením - V rámci absolvovania ŠRaVVP Závislosti došlo u odsúdeného k pozorovateľnému zlepšeniu vo viacerých cieľových oblastiach ako je motivácia k životu bez závislostí, vedomostí a náhľadu na závislosť a rizikové faktory spojené s návratom k závislému správaniu, k zlepšeniu uvedomenia si vlastných rizikových vlastností a správania alebo k zlepšeniu zručností zvládať rizikové situácie, ktoré môžu viesť k návratu k závislému správaniu. Je predpoklad, že sa po prepustení bude usilovať udržať abstinenciu, aktívne sa vyhýbať rizikovým situáciám z hľadiska možného návratu k závislému správaniu a že vyhľadá odbornú či laickú pomoc pre ďalšie upevňovanie správania smerom k zdravému životnému štýlu bez závislosti",
          "S výrazným zlepšením - V rámci absolvovania ŠRaVVP Závislosti došlo u odsúdeného k výraznému zlepšeniu náhľadu na oblasť závislostí, k zlepšeniu uvedomenia si vlastných rizikových vlastností a správania, a k zlepšeniu zručností zvládať rizikové situácie, ktoré môžu znamenať návrat k závislému správaniu. Je predpoklad, že sa po prepustení bude usilovať udržať abstinenciu, aktívne sa vyhýbať rizikovým situáciám z hľadiska možného návratu k závislému správaniu a že vyhľadá odbornú či laickú pomoc pre ďalšie upevňovanie správania smerom k zdravému životnému štýlu bez závislosti."
        ]
      }
    },
  }),

  methods: {
    getItemFunction(id) {
      return apiService.getGeneralZavislostiPo(id);
    },
    updateItemFunction(item, id) {
      return apiService.updateGeneralZavislostiPo(item, id);
    }
  },
};
</script>